import { render, staticRenderFns } from "./DeleteMetricsModal.vue?vue&type=template&id=231f6ff8&scoped=true&"
import script from "./DeleteMetricsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteMetricsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f6ff8",
  null
  
)

export default component.exports